var getFieldValue = function getFieldValue(field) {
  if (field.options && field.type !== 'select') {
    return field.options.filter(function (option) {
      return option.defaultChecked;
    }).map(function (option) {
      return option.value;
    });
  }

  return field.value || '';
};

export { getFieldValue };